import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { SegmentSettings } from '../interfaces/accounting.interface';

// update is deliberately not implemented: the backend exposes segment settings as
// read-only by design (no route is wired to accept a write).
export const SegmentSettingsService = {
    get: async (): Promise<SegmentSettings> => {
        const institutionId = AuthService.getSelectedInstitution();
        const res = await axios.get(ENDPOINTS.SEGMENT_SETTINGS.BY_INSTITUTION(institutionId!));
        return res.data;
    },
};
